import { apiBaseUrl } from 'yxt-biz-pc/packages/api';

// 用户注册信息获取
export const FetchRegisterInfo = (id) => {
  return apiBaseUrl.get('/sdproject/register/user/arrange/get', { params: { id } });
};
